import React from "react";
import styled from "styled-components";

const Block = ({ children, isBlock, loader, style }) => {
  return (
    <div className="block" style={{ ...style }}>
      {children}
      {isBlock && (
        <StyledOverlay>
          {loader ?? <div className="loading position-absolute" />}
        </StyledOverlay>
      )}
    </div>
  );
};

export default Block;

const StyledOverlay = styled.div`
  background-color: #f3f3f399;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
  outline: 0;
  border-radius: 0.5rem;
  z-index: 1;
`;
